module.exports = "<div class=\"panel panel-default\" ng-init=\"choiceCtrl.init()\">\n\t<div class=\"panel-heading\">\n\t\tMake Choice\n\t</div>\n\t<div class=\"panel-body\">\n\t\t<h3>Follow your heart: </h3>\n\t\t\n\t\t<ul class=\"list-group\">\n\t\t\t<li class=\"list-group-item\"\n\t\t\t\tng-repeat=\"choice in choiceCtrl.flow.context.choices\"\n\t\t\t\tng-click=\"choiceCtrl.flow.context.currentChoice=choice\">\n\t\t\t\t<a href=\"javascript:void(0)\">choice.label</a>\n\t\t\t</li>\n\t\t</ul>\n\t</div>\n\t<div class=\"panel-footer\">\n\t\t<button class=\"btn btn-sm btn-primary\" ng-click=\"choiceCtrl.next()\">Next</button>\n\t</div>\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./src/modules/demo/flow/templates/choice.html
 ** module id = 148
 ** module chunks = 0
 **/